export default __webpack_public_path__ + "static/media/icon_subscription-required@2x.171b878a.png";